import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	licenseColumn,
	numberBelongsToColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters, ownAccountsScopeRule } from '../filter-rules';

/**
 * Wrong Number on File (PD-16254) — active buyers whose number on file is held at the regulator by a different business (name and street number both differ). The matchmaker flags these (match_signals.numberCollision); the fix is a corrected number, reviewed in the matchmaker.
 */
export const wrongNumberList: ListBuilderList = {
	id: 'compliance-wrong-number',
	cacheTTL: 300000,
	// Tab label, deliberately short: the tabs must fit the Needs Attention
	// strip at 1440px before the More dropdown swallows them (Chris,
	// 2026-09-20). The full name is above and on the dashboard card.
	name: 'Wrong #',
	type: 'default',
	active: true,
	sortOrder: 3,
	filterRules: {
		...hideOtherCardFilters(['licenseNumberCollision']),
		licenseSalesRep: ownAccountsScopeRule,
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseNumberCollision: {
			defaultValue: [
				{ id: 'yes', label: 'Number belongs to another business' },
			],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		numberBelongsToColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
